import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  ListSubheader,
  styled,
  Typography,
  Box,
  useTheme,
  Collapse
} from '@mui/material';
import { IconChevronDown, IconChevronRight } from '@tabler/icons';
import { useSelector } from 'react-redux';
import NavItem from '../NavItem';

const NavGroup = ({ item, hideMenu, pathDirect = '' }) => {
  const theme = useTheme();
  const customizer = useSelector((state) => state.customizer);
  const [open, setOpen] = useState(false);
  const [isActive, setIsActive] = useState(false);

  // Check if any child item is active
  useEffect(() => {
    const checkActive = () => {
      if (item?.items) {
        const active = item.items.some(child => {
          if (!child?.href) return false;
          return pathDirect === child.href ||
            (child.href !== '/' && pathDirect?.startsWith?.(child.href));
        });
        setIsActive(active);
        if (active) setOpen(true);
      }
    };
    checkActive();
  }, [pathDirect, item?.items]);

  const ListSubheaderStyled = styled('div')(({ theme }) => ({
    ...theme.typography.overline,
    fontWeight: '700',
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(0),
    color: theme.palette.text.primary,
    lineHeight: '26px',
    padding: '3px 12px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderRadius: `${customizer.borderRadius}px`,
  }));

  const handleToggle = () => {
    setOpen(!open);
  };

  return (
    <>
      <ListSubheaderStyled onClick={handleToggle}>
        <Box display="flex" alignItems="center">
          {item?.icon && (
            <Box component="span" sx={{ mr: 1, display: 'flex' }}>
              <item.icon stroke={2} size="1.3rem" />
            </Box>
          )}
          {!hideMenu && (
            <Typography variant="subtitle2" fontWeight="600">
              {item?.subheader || 'Untitled'}
            </Typography>
          )}
        </Box>
        {!hideMenu && (
          <Box component="span">
            {open ? (
              <IconChevronDown size="1rem" />
            ) : (
              <IconChevronRight size="1rem" />
            )}
          </Box>
        )}
      </ListSubheaderStyled>

      {item?.items && (
        <Collapse in={open && !hideMenu} timeout="auto" unmountOnExit>
          <Box sx={{ pl: item?.icon ? 4 : 2 }}>
            {item.items.map((menuItem) => {
              if (!menuItem) return null;
              return (
                <NavItem
                  item={menuItem}
                  key={menuItem.id || menuItem.title}
                  pathDirect={pathDirect}
                  hideMenu={hideMenu}
                  level={1}
                />
              );
            })}
          </Box>
        </Collapse>
      )}
    </>
  );
};

NavGroup.propTypes = {
  item: PropTypes.shape({
    subheader: PropTypes.string,
    items: PropTypes.array,
    icon: PropTypes.elementType,
  }),
  hideMenu: PropTypes.bool,
  pathDirect: PropTypes.string,
};

NavGroup.defaultProps = {
  item: {
    subheader: '',
    items: [],
    icon: null,
  },
  hideMenu: false,
  pathDirect: '',
};

export default NavGroup;